import {
  SPECKLE_INTEGRATION_TYPE,
  type EquationExcelClientApp,
  type EquationExcelClientMetadata,
  type EquationExcelClientProfile,
  type ExtendedDocument,
  type VisibleExcelProfile,
} from "@/services/open-api/openApi.types";
import type { SpeckleModel } from "@haskoning/js-speckle";

export function getEquationExcelClientMetadata(schema: ExtendedDocument): EquationExcelClientMetadata | undefined {
  return schema.equation?.excel_client;
}

function getVisibleExcelProfilesForApp(app: EquationExcelClientApp): VisibleExcelProfile[] {
  return app.profiles.filter((profile) => !profile.disabled && !profile.hidden).map((profile) => ({ app, profile }));
}

export function getVisibleExcelProfiles(metadata: EquationExcelClientMetadata): VisibleExcelProfile[] {
  return metadata.apps.flatMap(getVisibleExcelProfilesForApp);
}

function getExcelAppKey(app: EquationExcelClientApp): string {
  return app.route ?? "";
}

function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function getExcelProfileKey(profile: EquationExcelClientProfile): string {
  return slugify(profile.profile_name);
}

export type SpeckleTransferProfileOption = VisibleExcelProfile & {
  apiUrl: string;
};

export function getTransferProfileKey(option: SpeckleTransferProfileOption): string {
  return [option.apiUrl, getExcelAppKey(option.app), getExcelProfileKey(option.profile)].join("|");
}
export function isSpeckleModelForApp(app: EquationExcelClientApp, model: SpeckleModel): boolean {
  return (model.versions?.items ?? []).some((version) => slugify(version.sourceApplication) === slugify(app.app_name));
}

function isSpeckleProfile(profile: EquationExcelClientProfile): boolean {
  return profile.type === SPECKLE_INTEGRATION_TYPE;
}

export function getSpeckleProfile(profile: EquationExcelClientProfile): EquationExcelClientProfile | null {
  return isSpeckleProfile(profile) ? profile : null;
}

export function hasSpeckleTransferProfile(profile: EquationExcelClientProfile): boolean {
  return Boolean(isSpeckleProfile(profile) && (profile.receive_speckle_endpoint || profile.send_speckle_endpoint));
}
